import React, { useState } from 'react';
import ChatContainer from './ChatContainer';
import ParentTeacherSelector from './ParentTeacherSelector';

/**
 * ParentChat - parent-facing messaging surface.
 *
 * Workflow: parent picks a child, sees that child's teachers, picks one to
 * message. All conversation/message/polling logic lives in ChatContainer —
 * this file only supplies the parent-specific selector and labels.
 */
const ParentChat = () => {
  const [selectedChild, setSelectedChild] = useState(null);

  return (
    <ChatContainer
      title="Messages to Teachers"
      subtitle="Connect with your child's teachers"
      userRole="parent"
      contactNoun="teacher"
      contextField="student_id"
      contextValue={selectedChild}
      recentlyMessagedStorageKey="recentlyMessagedTeachers"
      renderSelector={({ onSelected, onCancel, recentlyMessaged }) => (
        <ParentTeacherSelector
          selectedChild={selectedChild}
          onChildChange={setSelectedChild}
          onTeacherSelected={onSelected}
          onCancel={onCancel}
          recentlyMessaged={recentlyMessaged}
        />
      )}
    />
  );
};

export default ParentChat;
